import { ProjectQuickbooksOrdersWidget } from '../components/widgets/project-supplier-orders-widget/project-quickbooks-orders.widget';
import { IWidgetDefinition } from '../types/widget-definition.interface';

export const ProjectQuickbooksOrdersWidgetDefinition: IWidgetDefinition = {
  component: ProjectQuickbooksOrdersWidget,
};
